import { createContext, useContext } from 'react';

import type { ReportStatus } from '../types';

export interface ReportUpdate {
  status: ReportStatus;
  error?: string;
}

export type UpdateHandler = (update: ReportUpdate) => void;

interface ReportsWebSocketContextValue {
  isConnected: boolean;
  // Track a report until it settles, with a handler for its updates. Returns a fn
  // that unsubscribes the handler but keeps tracking (so the list still refreshes
  // if the popup closed first).
  trackUntilSettled: (reportId: number, handler: UpdateHandler) => () => void;
  // Stop tracking. Call when the report settles off-socket (e.g. polling fallback).
  untrackReport: (reportId: number) => void;
}

const ReportsWebSocketContext = createContext<ReportsWebSocketContextValue>({
  isConnected: false,
  trackUntilSettled: () => () => undefined,
  untrackReport: () => undefined,
});

export const useReportsWebSocketContext = () =>
  useContext(ReportsWebSocketContext);

export default ReportsWebSocketContext;
